import { render, staticRenderFns } from "./WikiSelector.vue?vue&type=template&id=421a1c09&"
import script from "./WikiSelector.vue?vue&type=script&lang=js&"
export * from "./WikiSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports